export const DESKTOP_SLIDER_INDENTS = {
  left: 42,
  right: 42,
  beetween: 16,
  // отступ для тултипа позиции
  top: 60,
  // отступ для тени карточек
  bottom: 16,
};

export const MOBILE_SLIDER_INDENTS = {
  left: 16,
  right: 16,
  beetween: 16,
  // отступ для тени карточек
  bottom: 16,
};
